import { render, staticRenderFns } from "./BasicGridTable.vue?vue&type=template&id=d089af6e"
import script from "./BasicGridTable.vue?vue&type=script&lang=js"
export * from "./BasicGridTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports